import { FontType } from '@primitives/Typography/types';
import { ButtonSize } from './types';

export const buttonSizeToFontType: Record<ButtonSize, FontType> = {
    small: 'h5',
    medium: 'h4',
    large: 'h3',
};
